var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBeginnerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 62,
    viewBox: "0 0 309 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_223_5079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 62
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 308,
    height: 62,
    rx: 16,
    fill: "#F8F5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_223_5079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 111.93,
    width: 151.417,
    height: 55.5163,
    transform: "rotate(-40.2257 87.5 111.93)",
    fill: "url(#paint0_linear_223_5079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.832 65C234.296 65 246.832 52.464 246.832 37C246.832 21.536 234.296 9 218.832 9C203.368 9 190.832 21.536 190.832 37C190.832 52.464 203.368 65 218.832 65Z",
    fill: "#E8DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.832 57.6317C230.227 57.6317 239.464 48.3946 239.464 37C239.464 25.6054 230.227 16.3683 218.832 16.3683C207.437 16.3683 198.2 25.6054 198.2 37C198.2 48.3946 207.437 57.6317 218.832 57.6317Z",
    fill: "#C9B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.789 46.0401L212.734 38.9348L216.901 43.0977L209.789 46.0401ZM219.382 44.787L221.02 40.8145L214.924 34.7318L210.945 36.3809L207.832 33.2682L226.822 26L229.832 29.0075L222.57 48L219.382 44.787Z",
    fill: "#F7F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1695 18.8756C76.4751 18.4972 75.8857 17.9518 75.4548 17.2888C75.3337 17.1025 75.1252 16.9918 74.9032 17.0005C74.6812 17.0091 74.4818 17.1356 74.3755 17.3305C73.9972 18.0249 73.4518 18.6143 72.7888 19.0453C72.6025 19.1664 72.4918 19.3749 72.5005 19.5969C72.5091 19.8189 72.6355 20.0182 72.8305 20.1246C73.5249 20.5029 74.1143 21.0483 74.5452 21.7112C74.6663 21.8975 74.8748 22.0082 75.0968 21.9995C75.3188 21.9909 75.5182 21.8644 75.6245 21.6695C76.0028 20.9751 76.5482 20.3857 77.2112 19.9547C77.3975 19.8336 77.5082 19.6251 77.4995 19.4031C77.4909 19.1811 77.3645 18.9819 77.1695 18.8756Z",
    fill: "#E4D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.798 24.7335C265.915 24.7311 265.047 24.5088 264.271 24.0869C264.053 23.9683 263.79 23.9705 263.576 24.0971C263.363 24.2236 263.234 24.4536 263.233 24.7016C263.231 25.5845 263.009 26.4534 262.587 27.229C262.468 27.447 262.471 27.7104 262.597 27.9239C262.724 28.1373 262.954 28.2658 263.202 28.2665C264.085 28.2689 264.953 28.4912 265.729 28.9131C265.947 29.0317 266.21 29.0295 266.424 28.9029C266.637 28.7764 266.766 28.5464 266.767 28.2984C266.769 27.4154 266.991 26.5468 267.413 25.7711C267.532 25.5531 267.529 25.2897 267.403 25.0762C267.277 24.8627 267.047 24.7342 266.798 24.7335Z",
    fill: "#E4D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1573 45.1372C58.2811 44.4504 57.5897 43.5562 57.1454 42.5355C57.0206 42.2488 56.7569 42.0466 56.4465 42.0071C56.1363 41.9674 55.8302 42.0966 55.6372 42.3428C54.9504 43.2189 54.0562 43.9104 53.0355 44.3546C52.7488 44.4794 52.5467 44.7431 52.5071 45.0535C52.4674 45.3637 52.5966 45.6698 52.8428 45.8628C53.7189 46.5496 54.4104 47.4438 54.8546 48.4645C54.9794 48.7512 55.2432 48.9533 55.5535 48.9929C55.8637 49.0326 56.1699 48.9034 56.3628 48.6572C57.0496 47.7811 57.9438 47.0896 58.9645 46.6454C59.2513 46.5206 59.4534 46.2568 59.493 45.9465C59.5325 45.6362 59.4034 45.3302 59.1573 45.1372Z",
    fill: "#C9B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.562 19.806C26.7434 19.3422 27.0375 18.9308 27.4176 18.609C27.5244 18.5186 27.577 18.3795 27.5541 18.2415C27.5311 18.1035 27.4363 17.989 27.306 17.938C26.8422 17.7566 26.4308 17.4625 26.109 17.0824C26.0186 16.9756 25.8796 16.923 25.7415 16.9459C25.6035 16.9689 25.489 17.0637 25.438 17.194C25.2566 17.6578 24.9625 18.0692 24.5824 18.391C24.4756 18.4814 24.423 18.6204 24.446 18.7585C24.4689 18.8965 24.5637 19.011 24.694 19.062C25.1578 19.2434 25.5693 19.5374 25.891 19.9175C25.9814 20.0243 26.1204 20.0769 26.2585 20.054C26.3965 20.0311 26.511 19.9363 26.562 19.806Z",
    fill: "#C9B3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_5079",
    x1: 239.649,
    y1: 139.957,
    x2: 108.808,
    y2: 139.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginnerBg);
export default __webpack_public_path__ + "static/media/beginner-bg.63ba6c5f26216d40825f8f525e6f24d1.svg";
export { ForwardRef as ReactComponent };